import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { unsubscribeRequest } from '@/api/unsubscibe';
import { Spinner } from '@/components/Spinner';
import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/heading';
import { Container } from '@/components/ui/container';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { IBackgroundImages } from '@/api/home/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const HeroUnsubscribe = ({
  email, subid,
}: {
  email: string, subid: string,
  backgroundImage?: IBackgroundImages, loading?: boolean,
}) => {
  const { t } = useOTSTranslation('common');

  const {
    isPending: isLoading, data, error, mutate,
  } = useMutation({
    mutationKey: ['unsubscribe'],
    mutationFn: () => unsubscribeRequest(subid, email),
  });

  const unsubscribeCb = useCallback(() => {
    mutate();
  }, [mutate]);

  return (
    <Container as="section" width="xl-only" className="px-4 py-16 md:py-24">
      <div className="mx-auto max-w-2xl space-y-6 text-center">
        {isLoading && <Spinner />}
        {!isLoading && !!error && (
          <>
            <Heading
              level={1}
            >
              {t('email.error.text')}
            </Heading>
            <div className="pt-2">
              <Button onClick={unsubscribeCb}>{t('email.unsubscribe.message')}</Button>
            </div>
          </>
        )}
        {!isLoading && data && (
          <Heading
            level={1}
          >
            {t('email.unsubscribe.text')}
          </Heading>
        )}
        {!isLoading && !error && !data && (
          <div className="pt-2">
            <Button onClick={unsubscribeCb}>{t('email.unsubscribe.message')}</Button>
          </div>
        )}
      </div>
    </Container>
  );
};
